<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col  >
		 <b-row class="breadcrumbrow mt-1 m-0">
				
				<b-col>
				
				 <h5 class="text-center">Seller Dashboard</h5>
				
				
				
				</b-col>
				<!--<b-col cols="6">
				</b-col>-->
				</b-row>
			<!--<b-row class="breadcrumbrow"><b-col>			
			<a v-if="!statusSidebar" href="javascript:void(0)" id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'">	<i class="fa fa-arrow-left" style="font-size:24px"></i> Close Menu</a>
			<a v-else href="javascript:void(0)"  id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'"><i class="fa fa-bars" aria-hidden="true" style="font-size:24px"></i></a>
			</b-col></b-row> -->
			
		<b-container fluid class="p-0 mt-2" >
		
		<b-tabs content-class="mt-3" fill pills  class="profileTab">
			<b-tab title="Account Details" active>
				<!-- <profile-account :profile="profile"></profile-account>-->
				<profile-account></profile-account>
			
			</b-tab>

			<b-tab title="Business Details" >
				<profile-business></profile-business>
			</b-tab>
			<b-tab title="Payment Details">
			<profile-bank></profile-bank>
			
			
			</b-tab>
			
		  </b-tabs>
		
		
		</b-container>
		
		
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
	
		
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import ProfileBank from "@/components/profile-bank.vue";
import ProfileAccount from "@/components/profile-account.vue";
import ProfileBusiness from "@/components/profile-business.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"profile-bank": ProfileBank,
		"profile-account": ProfileAccount,
		"profile-business": ProfileBusiness,
	},
	mounted(){
		//var self = this;
       // Object.assign(self.selectedItem, self.emptyItem);
        
		this.initProfile();
	},
	data() {
            return{
            loading: true, 
            addOfficeaddress:0,			
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_csv: null,
			statusSidebar: false,
            model_maps: {},		
            profile: {
                details: {
                    address:null,
                    category: null,
                    city:null,
                    dob:null,
                    gender: null,
                    payment_detail:{
                        beneficiary:null,
                        account:null,
                        bank:null,
                        ifsc:null
                    },
                    pincode:null,
                    social:{
                        facebook:null,
                        instagram:null,
                        tweeter:null,
                        whatsapp:null
                    },
                    state:null,
                    shipping:{
                        address:null,
                        city:null,
                        state:null,
                        pincode:null
                    },
                },
                
                email:'',
                phone:'',
                username:'',
                firstname:'',
                lastname:'',
                image:'',
                address:'',
                location:'',
                city:'',
                state:'',
                pincode:'',
                country:'',
                social:'',
				
            },
            recordUrl: this.$root.NEWAPIURL+'sellerapi/load-profile',
            updateUrl: this.$root.NEWAPIURL+'sellerapi/update-profile',
            categories: [
                { text: 'Fashion', value: 'fashion' },
                { text: 'Cosmetics', value: 'cosmetics' },
                { text: 'Vouchers', value: 'vouchers' },
                { text: 'Organic', value: 'organic' },
                { text: 'Home Essentials', value: 'home-essentials' }
            ],
            categoryOptions: [],
            breadcrumb: [
                    {
                        text: 'Home',
                        href: '/'
                    },
                    {
                        text: 'Products',
                        active: true
                    }
            ],
            /*fields: [
                { key: 'id', label: 'ID'},
                { key: 'records', label: 'Records'},
                { key: 'insert_time', label: 'Insert Time'},
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
            ],*/
            itemfields:[
                { key: 'product_id', label: 'PID'},
                { key: 'sku', label: 'SKU'},
                { key: 'total_images', label: 'TOTAL IMAGES'},
				{ key: 'status', label: 'Status' },
            ],
            totalRows: 1,
            currentPage: 1,
            pageOptions: [10, 20, 50, 100],
            perPage: 10,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            selectedItem: {product_data:{}, tier_price:[]},
            
            counterindex:1
	};
    },
	methods: {
		saveProfile(){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to update profile!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
                            console.log(self.profile.details);
                            if(value == true){
                                self.axios.post(self.updateUrl, {
                                    accesskey: self.$session.get('access_key'),
                                    data: self.profile,
                                }).then(function (response) {
                                    if(response.data.error == 0 || response.data.error == '0'){
                                        self.$bvToast.toast(response.data.message, {
                                                title: 'Update Status',
                                                toaster: 'b-toaster-bottom-right',
                                                autoHideDelay: 5000,
                                                variant: 'warning',
                                                solid: true,
                                                appendToast: true
                                        });
                                        self.initProfile();
                                    }

                                }).catch(function (error) {
                                        alert(error);
                                });
                                
                            }else{
                                    //alert('no '+item.id);
                            }
			}).catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		initProfile(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    var tmp = response.data.result;
                    //var payment_detail = JSON.parse(tmp.details.payment_detail);

                   // var social = JSON.parse(tmp.details.social);
                   // var shipping = JSON.parse(tmp.details.shipping);
                   // var category = JSON.parse(tmp.details.category);
                    //self.profile = tmp;
                    
                    self.profile.phone = tmp.phone;
                    self.profile.email = tmp.email;					
                    self.profile.username = tmp.username;					
                    self.profile.firstname = tmp.firstname;
                    self.profile.lastname = tmp.lastname;
                    self.profile.image = tmp.image;
                    self.profile.address = tmp.address;
                    self.profile.location = tmp.location;
                    self.profile.city = tmp.city;
                    self.profile.state = tmp.location;
                    self.profile.pincode = tmp.pincode;
                    self.profile.country = tmp.country;
                    self.profile.social = tmp.social;
                    /*self.profile.details={
                        address:(tmp && tmp.details.address)||null,
                        category: category||null,
                        city:(tmp && tmp.details.city)||null,
                        dob:(tmp && tmp.details.dob)||null,
                        gender: (tmp && tmp.details.gender)||null,
                        payment_detail:{
                            beneficiary:(payment_detail && payment_detail.beneficiary)||null,
                            account:(payment_detail && payment_detail.account)||null,
                            bank:(payment_detail && payment_detail.bank)||null,
                            ifsc:(payment_detail && payment_detail.ifsc)||null
                        },
                        pincode:(tmp && tmp.details.pincode)||null,
                        social:{
                            facebook:(social && social.facebook) || null,
                            instagram:(social && social.instagram) || null,
                            tweeter:(social && social.tweeter) || null,
                            whatsapp:(social && social.whatsapp) || null
                        },
                        state:(tmp && tmp.details.state)||null,
                        shipping:{
                            address:(shipping && shipping.address) || null,
                            city:(shipping && shipping.city) || null,
                            state:(shipping && shipping.state) || null,
                            pincode:(shipping && shipping.pincode) || null,
                        },
                    }*/
                    self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		
	}
}
</script>
<!-- scoped  -->
<style scoped lang="scss">

</style>